<script>
export default {
  name: 'AoikumoDisabledTooltip',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
  },
};
</script>

<template>
  <span
    v-tooltip="
      disabled ? message || $t('AOIKUMO_READ_ONLY.TOOLTIP_MESSAGE') : ''
    "
  >
    <slot />
  </span>
</template>
